import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LengthAwarePaginatorComponent } from './length-aware-paginator.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        LFDropdownModule.forRoot(),
    ],
    exports: [LengthAwarePaginatorComponent],
    declarations: [LengthAwarePaginatorComponent],
})
export class LengthAwarePaginatorModule
{
}
